import React from 'react';
import {ServerComponentCaller} from '../../helpers'


const LicenciaClaseA1 = props => <ServerComponentCaller url={"assets/data/pages/licencias/A1.json"}/>

export default LicenciaClaseA1